import { useEffect } from 'react';

/**
 * Custom hook to prevent body scrolling when a modal is open
 * @param {boolean} isLocked - Whether to lock the body scroll
 */
const useScrollLock = (isLocked) => {
  useEffect(() => {
    if (isLocked) {
      // Store the current scroll position
      const scrollY = window.scrollY;
      
      // Apply styles to prevent scrolling
      document.body.style.position = 'fixed';
      document.body.style.top = `-${scrollY}px`;
      document.body.style.width = '100%';
      document.body.style.overflow = 'hidden';
      
      // Return cleanup function
      return () => {
        // Restore the original styles
        document.body.style.position = '';
        document.body.style.top = '';
        document.body.style.width = '';
        document.body.style.overflow = '';
        
        // Restore the scroll position
        window.scrollTo(0, scrollY);
      };
    }
  }, [isLocked]);
};

export default useScrollLock;
